import getValueFees from 'core/controllerPlans/getValueFees'
import getBaseRate from 'core/controllerPlans/getBaseRate'
import moneyFormat from 'utils/format/money'

const asMoney = moneyFormat

const getSubscription = plan =>
  plan && plan.durations
    ? getValueFees('subscription', plan.durations[0].monthly.fees)
    : 0
const getCFA = plan =>
  plan && plan.durations
    ? getValueFees('communicatingForAmerica', plan.durations[0].monthly.fees)
    : 0

export function getDentalFeesBreakdown(dental, vision) {
  const subscriptionDental = getSubscription(dental)
  const subscriptionVision = getSubscription(vision)
  const subscription = subscriptionDental + subscriptionVision
  const baseRateDental = getBaseRate(dental)
  const baseRateVision = getBaseRate(vision)
  const baseRate = baseRateDental + baseRateVision

  return {
    cfa: getCFA(dental) ? asMoney(getCFA(dental)) : undefined,
    subscription,
    subscriptionDental,
    subscriptionVision,
    baseRateDental,
    baseRateVision,
    baseRate
  }
}

function detailsDentalFees(dental, vision = undefined) {
  const { cfa, subscription, baseRate } = getDentalFeesBreakdown(dental, vision)
  return `*Includes ${asMoney(baseRate)} of premium${cfa ? ', a' : ' and'} ${asMoney(
    subscription
  )} monthly administrative fee${cfa ? ` and ${cfa} for monthly association dues.` : '.'}`
}

export default detailsDentalFees
